import React, { useContext } from 'react';
import { Input } from '../../../../../SubComponents/Inputs';
import useTypeSafeLocalize from '../../../../../Hooks/use-type-safe-localize';
import {
  CustomerLocalization,
  LocalizationCategory,
} from '../../../../../localizations/types';
import { customerReducerActionTypes } from '../../../../../redusers/customer-reducer';
import { bookingState } from '../../../client-state/booking-state-context';
import useBookingMinimalShop from '../../../server-data/use-booking-minimal-shop';

interface AdditionalCustomerDataFormProps {
  pinError?: boolean;
  setPinError: React.Dispatch<React.SetStateAction<boolean>>;
}

const AdditionalCustomerDataForm = (props: AdditionalCustomerDataFormProps) => {
  const { data: minimalShop } = useBookingMinimalShop();
  const { state, dispatch } = useContext(bookingState);
  const localize = useTypeSafeLocalize();

  if (minimalShop?.country !== 'Italy') {
    return null;
  }

  const pinInputProps: React.ComponentProps<typeof Input> = {
    type: 'text',
    name: 'pin',
    error: props.pinError,
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => {
      props.setPinError(false);
      dispatch({
        type: customerReducerActionTypes.UPDATE_CUSTOMER,
        payload: { ...state.customer.customer, pin: event.target.value },
      });
    },
    onBlur: () => {
      props.setPinError(
        !/^[A-Za-z0-9]{15}[A-Za-z]$/.test(state.customer.customer.pin ?? '')
      );
    },
    value: state.customer.customer.pin,
    placeholder: localize(LocalizationCategory.customer, CustomerLocalization.pin),
    required: true,
    mb: '24px',
    autocomplete: 'city',
    matchStripeAppearance: true,
  };

  return (
    <div>
      <Input {...pinInputProps} />
    </div>
  );
};

export default AdditionalCustomerDataForm;
